import { useState } from 'react'

export function CurrenciesPage() {
  const [currencies, setCurrencies] = useState([
    { id: '1', code: 'PHP', name: 'Philippine Peso', symbol: '₱', isBase: true },
    { id: '2', code: 'USD', name: 'US Dollar', symbol: '$', isBase: false },
    { id: '3', code: 'EUR', name: 'Euro', symbol: '€', isBase: false },
  ])

  const [exchangeRates, setExchangeRates] = useState([
    { id: '1', targetCurrency: 'USD', rate: 56.5, date: '2023-10-01' },
    { id: '2', targetCurrency: 'EUR', rate: 60.2, date: '2023-10-01' },
  ])

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Currencies & Exchange Rates</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Currencies Table */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold text-gray-800">Currencies</h2>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm font-medium transition-colors">
              Add Currency
            </button>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="border-b border-gray-200 bg-gray-50 text-sm text-gray-600">
                  <th className="py-3 px-4 font-medium">Code</th>
                  <th className="py-3 px-4 font-medium">Name</th>
                  <th className="py-3 px-4 font-medium">Symbol</th>
                  <th className="py-3 px-4 font-medium">Base</th>
                </tr>
              </thead>
              <tbody>
                {currencies.map(c => (
                  <tr key={c.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="py-3 px-4 text-sm font-medium text-gray-900">{c.code}</td>
                    <td className="py-3 px-4 text-sm text-gray-600">{c.name}</td>
                    <td className="py-3 px-4 text-sm text-gray-600">{c.symbol}</td>
                    <td className="py-3 px-4 text-sm">
                      {c.isBase ? (
                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                          Base
                        </span>
                      ) : (
                        <span className="text-gray-400">-</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Exchange Rates Table */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold text-gray-800">Exchange Rates (vs PHP)</h2>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm font-medium transition-colors">
              Update Rate
            </button>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="border-b border-gray-200 bg-gray-50 text-sm text-gray-600">
                  <th className="py-3 px-4 font-medium">Currency</th>
                  <th className="py-3 px-4 font-medium">Rate</th>
                  <th className="py-3 px-4 font-medium">Effective Date</th>
                </tr>
              </thead>
              <tbody>
                {exchangeRates.map(er => (
                  <tr key={er.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="py-3 px-4 text-sm font-medium text-gray-900">{er.targetCurrency}</td>
                    <td className="py-3 px-4 text-sm text-gray-600">₱ {er.rate.toFixed(2)}</td>
                    <td className="py-3 px-4 text-sm text-gray-600">{er.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
